import React, { useMemo, useCallback, useRef, useEffect } from 'react';
import {reduxForm } from 'redux-form';
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from "@material-ui/core/InputLabel";
import Tooltip from "@material-ui/core/Tooltip";
import GridList from '@material-ui/core/GridList';
import UploadNoticePhoto from './uploadNoticePhoto';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Skeleton from '@material-ui/lab/Skeleton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import axios from 'axios';
import _ from 'lodash';

const styles = theme => ({
    form: {
        width: '140%',
        height: '180%',
        backgroundColor: "white",
        overflow: "auto",
        flexGrow: 1     

    },
    header: {
        height: '15%',
        margin: '0px 0px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.primary.main,
    },
    bodyheader: {
        height: '15%',
        margin: '15px 0px 0px 0px',
        width: '100%',
        display: 'flex',
        alignItems: 'left',
        justifyContent: 'left',

    },
    content: {
        height: '60%',
        margin: '10px 0px',
        overflow: 'hidden',
    },
    footer: {
        height: '10%',
        margin: '20px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

    },
    headGridTwo: {
        float: 'right',
        marginRight: '2px'
    },
    addText: {
        fontSize: "15px"
    },
    appBarSpacer: theme.mixins.toolbar,
    body: {


    },
    img: {
        display: "flex"
    },
    div2: {
        marginTop: "20px 0px 0px 0px"
    },
    div1: {
        width: "screen",
        padding: "10px 10px 10px 10px",
        borderBottom: "1px solid gray",
        overflow: "auto",
    },
    imgIcon: {
        width: "inherit!important",
        height: "inherit!important",
        padding: "4px",
       

    },
    imgMessage: {
        width: "inherit!important",
        height: "inherit!important",
        alignItems : "center",
        justifyContent : "center"
       

    },
    customImageContainerPreview: {
        height: "-webkit-fill-available!important",
        width: "-webkit-fill-available!important",
    },
    gridListIcon: {
        width: 'auto',
        height: "-webkit-fill-available!important",
        background: "#c2aece 0% 0% no-repeat padding-box",
        border:" 1px solid #748A9D1A",
        borderRadius: "5px",
        opacity: "1",
        padding : "4px 4px 4px 4px"
    },

    gridElementIcon: {
        margin: '10px 5px'
    },
    uploadField :{
        display : "inline-flex!important",
        justifyContent : "space!import"
    },
    row1:{
        padding : "8px 8px 8px 8px"
    },
    uploadAddButton:{
    padding : "10px"
    },
    selectedProductsContainer: {
        marginTop: "10px",
        padding: "10px",
        border: "1px solid #e0e0e0",
        borderRadius: "4px"
    },
    selectedBusinessesContainer: {
        marginTop: "10px",
        padding: "10px",
        border: "1px solid #e0e0e0",
        borderRadius: "4px"
    },
    productChip: {
        margin: "4px"
    },
    businessChip: {
        margin: "4px"
    },
    searchResultsContainer: {
        maxHeight: "200px",
        overflowY: "auto",
        border: "1px solid #e0e0e0",
        borderRadius: "4px",
        marginTop: "4px"
    },
    searchResultItem: {
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#f5f5f5"
        }
    },
    loadingContainer: {
        padding: "10px",
        textAlign: "center"
    },
    noResultsContainer: {
        padding: "20px",
        textAlign: "center",
        color: "#999"
    },
    skeletonItem: {
        margin: "8px"
    }
});


class AddCatalogAdForm extends React.Component {
  constructor() {
    super();
    this.state = {
      adTitle: "",
      businessId: "",
      businessName: "",
      role: "",
      noticeType: "",
      message: "",
      isUploading: false,
      selectedPhoto: null,
      typePhoto: "",
      path: "",
      title: "",
      preview: false,
      notificationBody: "",
      productIds: [],
      productSearchText: "",
      productSearchResults: [],
      selectedProducts: [],
      isActive: false,
      isSearchingProducts: false,
      // Business search states
      businessSearchText: "",
      businessSearchResults: [],
      selectedBusiness: null, // Single business instead of array
      isSearchingBusinesses: false,
      businessSearchPage: 0,
      businessSearchHasMore: true,
      productSearchPage: 0,
      productSearchHasMore: true,
    };
    this.inputReference = React.createRef();
    this.businessSearchDebounced = _.debounce(this.fetchBusinesses, 500);
    this.productSearchDebounced = _.debounce(this.fetchProducts, 500);
    this.businessSearchAbortController = null;
    this.productSearchAbortController = null;
  }

  componentDidMount() {
    this.setState({ path: "" });
    this.clearData();
  }

  componentWillUnmount() {
    // Cancel any pending requests
    if (this.businessSearchAbortController) {
      this.businessSearchAbortController.abort();
    }
    if (this.productSearchAbortController) {
      this.productSearchAbortController.abort();
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  fetchBusinesses = async (searchValue) => {
    if (!searchValue || searchValue.trim().length < 2) {
      this.setState({ businessSearchResults: [], isSearchingBusinesses: false });
      return;
    }

    // Cancel previous request
    if (this.businessSearchAbortController) {
      this.businessSearchAbortController.abort();
    }
    this.businessSearchAbortController = new AbortController();

    this.setState({ isSearchingBusinesses: true, businessSearchPage: 0 });

    try {
      const response = await axios.get('/api/noticeApp/findBySearchQuery', {
        params: {
          searchTag: searchValue,
          limit: 20,
          skip: 0
        },
        signal: this.businessSearchAbortController.signal
      });

      if (response.data && Array.isArray(response.data)) {
        const businesses = response.data.map(business => ({
          id: business._id,
          businessId: business.businessId,
          businessName: business.businessName
        }));
        this.setState({ 
          businessSearchResults: businesses,
          businessSearchHasMore: businesses.length === 20
        });
      } else {
        this.setState({ businessSearchResults: [], businessSearchHasMore: false });
      }
    } catch (error) {
      if (error.name !== 'CanceledError') {
        console.error("Error searching businesses:", error);
        this.setState({ businessSearchResults: [] });
      }
    } finally {
      this.setState({ isSearchingBusinesses: false });
    }
  };

  handleBusinessSearch = (event) => {
    const searchValue = event.target.value;
    this.setState({ businessSearchText: searchValue });
    this.businessSearchDebounced(searchValue);
  };

  handleBusinessSelect = (business) => {
    if (business) {
      // Replace existing business with new one (only one business allowed)
      this.setState({
        selectedBusiness: business,
        businessId: business.businessId,
        businessName: business.businessName,
        businessSearchText: "",
        businessSearchResults: []
      });
    }
  };

  handleBusinessRemove = () => {
    // Remove the single selected business
    this.setState({
      selectedBusiness: null,
      businessId: "",
      businessName: ""
    });
  };

  fetchProducts = async (searchValue) => {
    const selectedBusinessId = this.state.selectedBusiness?.id;
    if (!searchValue || searchValue.trim().length < 2 || !selectedBusinessId) {
      this.setState({ productSearchResults: [], isSearchingProducts: false });
      return;
    }

    // Cancel previous request
    if (this.productSearchAbortController) {
      this.productSearchAbortController.abort();
    }
    this.productSearchAbortController = new AbortController();

    this.setState({ isSearchingProducts: true, productSearchPage: 0 });

    try {
      // Search products for the first selected business (or you can search across all)
      const businessId = selectedBusinessId;
      const response = await axios.get(`/api/noticeApp/getFilteredServices/${businessId}`, {
        params: {
          serviceName: searchValue,
          limit: 20,
          skip: 0
        },
        signal: this.productSearchAbortController.signal
      });
      
      if (response.data && response.data.services && Array.isArray(response.data.services)) {
        const products = response.data.services.map(service => ({
          id: String(service._id), // Ensure ID is a string
          serviceId: service.serviceId || '',
          name: service.service || '',
          businessId: service.businessId ? String(service.businessId) : ''
        }));
        
        this.setState({ 
          productSearchResults: products,
          productSearchHasMore: products.length === 20,
          isSearchingProducts: false
        });
      } else {
        this.setState({ 
          productSearchResults: [], 
          productSearchHasMore: false,
          isSearchingProducts: false
        });
      }
    } catch (error) {
      if (error.name !== 'CanceledError') {
        console.error("Error searching products:", error);
        this.setState({ 
          productSearchResults: [],
          isSearchingProducts: false
        });
      } else {
        // Request was canceled, don't update state
        this.setState({ isSearchingProducts: false });
      }
    }
  };

  handleProductSearch = (event) => {
    const searchValue = event.target.value;
    this.setState({ productSearchText: searchValue });
    this.productSearchDebounced(searchValue);
  };

  handleProductSelect = (product) => {
    if (product && !this.state.selectedProducts.find(p => p.id === product.id)) {
      this.setState({
        selectedProducts: [...this.state.selectedProducts, product],
        productIds: [...this.state.productIds, product.id],
        productSearchText: "",
        productSearchResults: []
      });
    }
  };

  handleProductRemove = (productId) => {
    this.setState({
      selectedProducts: this.state.selectedProducts.filter(p => p.id !== productId),
      productIds: this.state.productIds.filter(id => id !== productId)
    });
  };

  handleProductIdsInput = (event) => {
    const value = event.target.value;
    // Allow comma-separated product IDs
    const ids = value.split(',').map(id => id.trim()).filter(id => id);
    this.setState({ productIds: ids });
    
    // Also update selectedProducts if needed
    if (ids.length > 0) {
      const existingProductIds = this.state.selectedProducts.map(p => p.id);
      const newIds = ids.filter(id => !existingProductIds.includes(id));
      if (newIds.length > 0) {
        // Add new product IDs as selected (without names, will be fetched if needed)
        const newProducts = newIds.map(id => ({
          id: id,
          name: `Product ${id}`,
          serviceId: id
        }));
        this.setState({
          selectedProducts: [...this.state.selectedProducts, ...newProducts]
        });
      }
    }
  };

  updateNoticePhoto = async (files, photoType) => {
    let data = new FormData();
    let folderPath = `Marketplace_Business/CatalogAd/`;
    let temp = files[0].name.split(".");
    let fileName = temp[0] + Math.ceil(Math.random() * 999999) + "." + temp[1];
    data.append("file", files[0]);
    data.append("folder", folderPath);
    data.append("public_id", `CatalogAd/${fileName}`);
    data.append(
      "upload_preset",
      this.props.envs.env.cloudinaryBusinessImagesUploadPreset
    );
    
    const uploadUrl = this.props.envs.env.cloudinaryUploadUrl;
    try {
      let res = await fetch(uploadUrl, {
        method: "POST",
        body: data,
      });
      
      let file = await res.json();
      
      if (photoType === "catalogadphoto") {
        let path = file.secure_url;
        let title = file.original_filename;
        this.setState({ path });
        this.setState({ title });
        this.setState({ isUploading: false, typePhoto: photoType });
      }
    } catch (err) {
      console.error('Upload error:', err.message);
      this.setState({ isUploading: false });
    }
  };

  clearData = () => {
    this.setState({
      adTitle: "",
      businessId: "",
      businessName: "",
      role: "",
      noticeType: "",
      path: "",
      message: "",
      title: "",
      preview: false,
      isUploading: false,
      selectedPhoto: null,
      notificationBody: "",
      productIds: [],
      selectedProducts: [],
      productSearchText: "",
      productSearchResults: [],
      isActive: false,
      businessSearchText: "",
      businessSearchResults: [],
      selectedBusiness: null,
      isSearchingBusinesses: false,
      businessSearchPage: 0,
      businessSearchHasMore: true,
      productSearchPage: 0,
      productSearchHasMore: true,
    });
  };

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmit = (formValues) => {
    // Get business from selected business (single business only)
    const selectedBusiness = this.state.selectedBusiness;
    const businessId = selectedBusiness ? selectedBusiness.id : this.state.businessId.trim();
    const businessName = selectedBusiness ? selectedBusiness.businessName : this.state.businessName.trim();
    const businessIdString = selectedBusiness ? selectedBusiness.businessId : "";

    formValues.adTitle = this.state.adTitle.trim();
    formValues.businessId = businessId;
    formValues.businessIds = businessId ? [businessId] : []; // Array with single business ID
    formValues.businessName = businessName;
    formValues.businessIdString = businessIdString;
    formValues.role = this.state.role;
    formValues.noticeType = this.state.noticeType;
    formValues.notificationBody = this.state.notificationBody;
    formValues.message = this.state.message.trim();
    formValues.path = this.state.path;
    formValues.title = this.state.title.trim();
    formValues.productIds = this.state.productIds;
    formValues.isActive = this.state.isActive;

    this.props.onSubmit(formValues);
  };

  render() {
    const { classes } = this.props;

    return (
      <form
        onSubmit={this.props.handleSubmit(this.onSubmit)}
        className={classes.form}
      >
        <div className={classes.appBarSpacer}>
          <Grid container className={classes.header} spacing={1}>
            <Grid item xs={8}>
              <Typography variant="h5" gutterBottom>
                Create Catalog Ad
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <CloseIcon
                className={classes.headGridTwo}
                onClick={() => {
                  this.props.onClose();
                }}
              />
            </Grid>
          </Grid>
          <Container className={classes.body}>
            <Grid>
              <Typography
                style={{ fontSize: "14px", fontWeight: "bolder" }}
                gutterBottom
              >
                Add Business (Name/ID)*
              </Typography>
              <TextField
                fullWidth
                margin="dense"
                name="businessSearchText"
                style={{ width: "92%" }}
                value={this.state.businessSearchText}
                variant="outlined"
                onChange={this.handleBusinessSearch}
                placeholder="Search by Business Name or ID (min 2 characters)"
                InputProps={{
                  endAdornment: this.state.isSearchingBusinesses ? (
                    <CircularProgress size={20} />
                  ) : null
                }}
              />
              
              {/* Business Search Results */}
              {this.state.businessSearchText && this.state.businessSearchText.length >= 2 && (
                <div className={classes.searchResultsContainer}>
                  {this.state.isSearchingBusinesses ? (
                    <div className={classes.loadingContainer}>
                      {[1, 2, 3].map((i) => (
                        <Skeleton key={i} variant="text" className={classes.skeletonItem} />
                      ))}
                    </div>
                  ) : this.state.businessSearchResults.length > 0 ? (
                    <List dense>
                      {this.state.businessSearchResults.map((business) => (
                        <ListItem
                          key={business.id}
                          button
                          onClick={() => this.handleBusinessSelect(business)}
                          className={classes.searchResultItem}
                          disabled={this.state.selectedBusiness?.id === business.id}
                        >
                          <ListItemText
                            primary={business.businessName}
                            secondary={`ID: ${business.businessId}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  ) : (
                    <div className={classes.noResultsContainer}>
                      <Typography variant="body2">No results found</Typography>
                    </div>
                  )}
                </div>
              )}

              {/* Selected Business */}
              {this.state.selectedBusiness && (
                <div className={classes.selectedBusinessesContainer}>
                  <Typography
                    style={{ fontSize: "12px", fontWeight: "bolder", marginBottom: "8px" }}
                    gutterBottom
                  >
                    Selected Business:
                  </Typography>
                  <Grid container spacing={1}>
                    <Grid item>
                      <Chip
                        label={`${this.state.selectedBusiness.businessName} (${this.state.selectedBusiness.businessId})`}
                        onDelete={this.handleBusinessRemove}
                        className={classes.businessChip}
                        color="primary"
                        variant="outlined"
                      />
                    </Grid>
                  </Grid>
                </div>
              )}
            </Grid>

            <Grid>
              <Typography
                style={{ fontSize: "14px", fontWeight: "bolder" }}
                gutterBottom
              >
                Ad Title*
              </Typography>
              <TextField
                fullWidth
                margin="dense"
                name="adTitle"
                style={{ width: "92%" }}
                value={this.state.adTitle}
                variant="outlined"
                onChange={this.handleFilterChange}
                placeholder="Enter Ad Title"
              />
            </Grid>

            <Grid style={{ display: "flex", flexDirection: "row" }}>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: "14px", fontWeight: "bolder" }}
                  gutterBottom
                >
                  Role*
                </Typography>
                <FormControl
                  style={{ width: "200px" }}
                  margin="dense"
                  variant="outlined"
                >
                  <InputLabel id="catalog-ad-role-label">
                    Select Role
                  </InputLabel>
                  <Select
                    labelId="catalog-ad-role-label"
                    id="catalog-ad-role-select"
                    value={this.state.role}
                    name="role"
                    label="Select Role"
                    onChange={this.handleChange}
                    style={{ width: "225px" }}
                  >
                    <MenuItem
                      value="Business"
                      style={{ minHeight: "28px", height: "28px" }}
                    >
                      Business
                    </MenuItem>
                    <MenuItem
                      value="Shopper"
                      style={{ minHeight: "28px", height: "28px" }}
                    >
                      Shopper
                    </MenuItem>
                    <MenuItem
                      value="Both"
                      style={{ minHeight: "28px", height: "28px" }}
                    >
                      Both
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ fontSize: "14px", fontWeight: "bolder" }}
                  gutterBottom
                >
                  Notice Type*
                </Typography>
                {this.state.role ? (
                  <FormControl
                    style={{ width: "200px" }}
                    margin="dense"
                    variant="outlined"
                  >
                    <InputLabel id="catalog-ad-notice-type-label">
                      Select Notice Type
                    </InputLabel>
                    <Select
                      labelId="catalog-ad-notice-type-label"
                      id="catalog-ad-notice-type-select"
                      value={this.state.noticeType}
                      name="noticeType"
                      onChange={this.handleChange}
                      style={{ width: "225px", border: "bold" }}
                      label="Select Notice Type"
                    >
                      <MenuItem
                        value="With Icon"
                        style={{ minHeight: "28px", height: "28px" }}
                      >
                        With Icon
                      </MenuItem>
                      <MenuItem
                        value="With Image"
                        style={{ minHeight: "28px", height: "28px" }}
                      >
                        With Image
                      </MenuItem>
                    </Select>
                  </FormControl>
                ) : (
                  <Tooltip title="Please Select Role" arrow>
                    <FormControl fullWidth margin="dense" variant="outlined">
                      <InputLabel id="catalog-ad-notice-type-label">
                        Select Notice Type
                      </InputLabel>
                      <Select
                        labelId="catalog-ad-notice-type-label"
                        id="catalog-ad-notice-type-select"
                        value={this.state.noticeType}
                        name="noticeType"
                        onChange={this.handleChange}
                        style={{ width: "225px", border: "bold" }}
                        label="Select Notice Type"
                        disabled={true}
                      >
                        <MenuItem
                          value="With Icon"
                          style={{ minHeight: "28px", height: "28px" }}
                        >
                          With Icon
                        </MenuItem>
                        <MenuItem
                          value="With Image"
                          style={{ minHeight: "28px", height: "28px" }}
                        >
                          With Image
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Tooltip>
                )}
              </Grid>
            </Grid>
            <Grid item xs={4}>
              {this.state.noticeType === "With Icon" ? (
                <Grid>
                  <Typography variant="h6" gutterBottom>
                    Upload Icon*
                  </Typography>
                  <Grid className={classes.uploadField}>
                    <TextField
                      margin="dense"
                      name="path"
                      variant="outlined"
                      style={{ width: "225px" }}
                      value={
                        this.state.path && this.state.title
                          ? this.state.title
                          : "Upload Icon"
                      }
                      InputProps={{
                        readOnly: true,
                        style: { color: "gray" }
                      }}
                    />
                    <Grid className={classes.uploadAddButton}>
                      <UploadNoticePhoto
                        uploadButtonName="+"
                        updateNoticePhoto={this.updateNoticePhoto}
                        photoType="catalogadphoto"
                        disabled={this.state.title ? true : false}
                        env={this.props.env}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
              {this.state.noticeType === "With Image" ? (
                <Grid>
                  <Typography variant="h6" gutterBottom>
                    Upload Image*
                  </Typography>
                  <Grid className={classes.uploadField}>
                    {" "}
                    <TextField
                      margin="dense"
                      name="path"
                      variant="outlined"
                      style={{ width: "225px" }}
                      value={
                        this.state.path && this.state.title
                          ? this.state.title
                          : "Upload Image"
                      }
                      InputProps={{
                        readOnly: true,
                        style: { color: "gray" }
                      }}
                    />
                    <Grid className={classes.uploadAddButton}>
                      <UploadNoticePhoto
                        uploadButtonName="+"
                        updateNoticePhoto={this.updateNoticePhoto}
                        photoType="catalogadphoto"
                        disabled={this.state.title ? true : false}
                        env={this.props.env}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}
            </Grid>
            {this.state.noticeType === "With Icon" ? (
              <Typography variant="h6" gutterBottom className={classes.div2}>
                Message*
                <TextField
                  margin="dense"
                  name="message"
                  variant="outlined"
                  id="outlined-multiline-static"
                  multiline
                  rows={3}
                  style={{ width: "100%" }}
                  placeholder="Type Your Message Here !"
                  value={this.state.message}
                  onChange={this.handleFilterChange}
                />
              </Typography>
            ) : (
              " "
            )}
            {this.state.noticeType === "With Image" ? (
              <Typography variant="h6" gutterBottom className={classes.div2}>
                Message*
                <TextField
                  margin="dense"
                  name="notificationBody"
                  variant="outlined"
                  id="outlined-multiline-static"
                  multiline
                  rows={3}
                  style={{ width: "100%" }}
                  placeholder="Type Your Message Here !"
                  value={this.state.notificationBody}
                  onChange={this.handleFilterChange}
                />
              </Typography>
            ) : (
              " "
            )}

            {/* Add Products Section - Optional */}
            <Grid>
              <Typography
                style={{ fontSize: "14px", fontWeight: "bolder" }}
                gutterBottom
              >
                Add Products (Optional)
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography
                    style={{ fontSize: "12px", fontWeight: "normal" }}
                    gutterBottom
                  >
                    Search by Product Name
                  </Typography>
                  <TextField
                    fullWidth
                    margin="dense"
                    name="productSearchText"
                    variant="outlined"
                    value={this.state.productSearchText}
                    onChange={this.handleProductSearch}
                    placeholder="Search products by name (min 2 characters)"
                    disabled={!this.state.selectedBusiness}
                    InputProps={{
                      endAdornment: this.state.isSearchingProducts ? (
                        <CircularProgress size={20} />
                      ) : null
                    }}
                  />
                  
                  {/* Product Search Results */}
                  {this.state.productSearchText && this.state.productSearchText.length >= 2 && this.state.selectedBusiness && (
                    <div className={classes.searchResultsContainer}>
                      {this.state.isSearchingProducts ? (
                        <div className={classes.loadingContainer}>
                          {[1, 2, 3].map((i) => (
                            <Skeleton key={i} variant="text" className={classes.skeletonItem} />
                          ))}
                        </div>
                      ) : this.state.productSearchResults.length > 0 ? (
                        <List dense>
                          {this.state.productSearchResults.map((product, index) => (
                            <ListItem
                              key={product.id || `product-${index}`}
                              button
                              onClick={() => this.handleProductSelect(product)}
                              className={classes.searchResultItem}
                              disabled={this.state.selectedProducts.find(p => p.id === product.id)}
                            >
                              <ListItemText
                                primary={product.name || 'Unnamed Product'}
                                secondary={`ID: ${product.serviceId || product.id || 'N/A'}`}
                              />
                            </ListItem>
                          ))}
                        </List>
                      ) : (
                        <div className={classes.noResultsContainer}>
                          <Typography variant="body2">No results found</Typography>
                        </div>
                      )}
                    </div>
                  )}
                </Grid>
                <Grid item xs={6}>
                  <Typography
                    style={{ fontSize: "12px", fontWeight: "normal" }}
                    gutterBottom
                  >
                    Add by Product IDs (comma-separated)
                  </Typography>
                  <TextField
                    fullWidth
                    margin="dense"
                    name="productIds"
                    variant="outlined"
                    value={this.state.productIds.join(', ')}
                    onChange={this.handleProductIdsInput}
                    placeholder="Enter Product IDs (e.g., id1, id2, id3)"
                    disabled={!this.state.selectedBusiness}
                  />
                </Grid>
              </Grid>
              {this.state.selectedProducts.length > 0 && (
                <div className={classes.selectedProductsContainer}>
                  <Typography
                    style={{ fontSize: "12px", fontWeight: "bolder", marginBottom: "8px" }}
                    gutterBottom
                  >
                    Selected Products:
                  </Typography>
                  <Grid container spacing={1}>
                    {this.state.selectedProducts.map((product) => (
                      <Grid item key={product.id}>
                        <Chip
                          label={`${product.name}${product.serviceId ? ` (${product.serviceId})` : ''}`}
                          onDelete={() => this.handleProductRemove(product.id)}
                          className={classes.productChip}
                          color="secondary"
                          variant="outlined"
                        />
                      </Grid>
                    ))}
                  </Grid>
                </div>
              )}
            </Grid>

            {/* Status Toggle */}
            <Grid style={{ marginTop: "10px" }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.state.isActive}
                    onChange={(e) => this.setState({ isActive: e.target.checked })}
                    color="primary"
                  />
                }
                label={this.state.isActive ? "Active" : "Inactive"}
              />
              <Typography style={{ fontSize: "12px", color: "gray" }}>
                Default: Inactive
              </Typography>
            </Grid>

            <Container className={classes.div2}>
              {this.state.noticeType === "With Icon" &&
              this.state.path &&
              this.state.message ? (
                <Grid container>
                  <Grid item xs={6}></Grid>
                  <Grid item xs={3}>
                    <Button
                      style={{ width: "90%" }}
                      variant="contained"
                      margin="normal"
                      color="default"
                      onClick={this.clearData}
                    >
                      RESET
                    </Button>
                  </Grid>
                  <Grid item xs={3}>
                    <Button
                      style={{ width: "90%" }}
                      variant="contained"
                      margin="normal"
                      onClick={() => {
                        this.setState({ preview: true });
                      }}
                      color="primary"
                    >
                      PREVIEW
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                <Grid container>
                  <Grid item xs={8}></Grid>
                  <Grid item xs={2}>
                    <Button
                      style={{ width: "90%" }}
                      variant="contained"
                      margin="normal"
                      color="default"
                      onClick={this.clearData}
                    >
                      RESET
                    </Button>
                  </Grid>
                  <Grid item xs={2}>
                    <Button
                      style={{ width: "90%" }}
                      variant="contained"
                      margin="normal"
                      disabled={
                        this.state.noticeType === "With Image" &&
                        this.state.title &&
                        this.state.notificationBody
                          ? false
                          : true
                      }
                      onClick={() => {
                        this.setState({ preview: true });
                      }}
                      color="primary"
                    >
                      PREVIEW
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Container>
            <Container className={classes.div1} />
            <Typography variant="h6" gutterBottom>
              Preview
            </Typography>
            {this.state.noticeType === "With Icon" ? (
              <Grid item xs={15}>
                {this.state.path !== "" && this.state.preview === true ? (
                  <GridList className={classes.gridListIcon}>
                    <a
                      href={this.state.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.imgIcon}
                    >
                      <img border="0" src={this.state.path} alt="" />
                    </a>
                    <Typography className={classes.imgMessage}>
                      {this.state.message}
                    </Typography>
                  </GridList>
                ) : null}
              </Grid>
            ) : null}
            {this.state.noticeType === "With Image" ? (
              <Grid item xs={15}>
                {this.state.path !== "" && this.state.preview === true ? (
                  <GridList className={classes.gridList}>
                    <a
                      href={this.state.path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        border="0"
                        src={this.state.path}
                        alt=""
                        className={classes.customImageContainerPreview}
                      />
                    </a>
                  </GridList>
                ) : null}
              </Grid>
            ) : null}

            <Container className={classes.footer}>
              <Grid container>
                <Grid item xs={8}></Grid>
                <Grid item xs={2}>
                  <Button
                    style={{ width: "90%" }}
                    variant="contained"
                    margin="normal"
                    color="default"
                    onClick={() => {
                      this.props.onClose();
                    }}
                  >
                    CANCEL
                  </Button>
                </Grid>
                <Grid item xs={2}>
                  <Button
                    type="submit"
                    style={{ width: "90%" }}
                    variant="contained"
                    margin="normal"
                    disabled={
                      (this.state.noticeType === "With Image" &&
                        this.state.title &&
                        this.state.adTitle &&
                        this.state.selectedBusiness &&
                        this.state.notificationBody) ||
                      (this.state.noticeType === "With Icon" &&
                        this.state.title &&
                        this.state.message &&
                        this.state.adTitle &&
                        this.state.selectedBusiness)
                        ? false
                        : true
                    }
                    color="primary"
                  >
                    SAVE
                  </Button>
                </Grid>
              </Grid>
            </Container>
          </Container>
        </div>
      </form>
    );
  }
}

export default reduxForm({
    form: 'AddCatalogAdForm',
})(withStyles(styles)(AddCatalogAdForm))

